import loadingTemplate from './loadingTemplate';
import { theme } from '../constants/defaults';
import { normalizeProductItem } from '../utils/product';
import cartModalItemTemplate from './cartModalItemTemplate';
import { renderFooter, modalFooter } from './cartModalFooterTemplate';

export default function(isLoading, state) {
  if (isLoading) {
    return loadingTemplate();
  }

  const { item_count: itemCount, items } = state;

  if (itemCount === 0) {
    return `
      <p>${theme.strings.cart_empty}</p>
      <button class="button js-modal-close">
        ${theme.strings.cart_continue_shopping}
      </button>

      ${modalFooter}
    `;
  }

  const itemsList = items.map(item => {
    if (item.id !== 47005477601620) {
      const itemObject = normalizeProductItem(item);
      return cartModalItemTemplate(itemObject);
    }

    return '';
  });

  let promoMessage = '';

  if (theme.settings.promoMessageEnabled) {
    promoMessage = `
  <p class="ajaxcart__card ajaxcart__card--promo | js-cart-promo">
    ${theme.strings.cart_promo_pate}
  </p>
  `;
  } else {
    promoMessage = '';
  }

  return `
    <form action="${theme.routes.cart}" method="post" novalidate class="ajaxcart">
    ${promoMessage}
    <div class="ajaxcart__inner">
        ${itemsList.join('')}
      </div>

      ${renderFooter(state)}
    </form>
  `;
}
